module.exports = __webpack_public_path__ + "static/media/sammy_capa.0e928d62.jpg";